import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  examinationColumns,
  examinationRows,
  fetchExaminationRows,
} from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";
import ConfirmModal from "../common/ConfirmModal";

const ExaminationDataTable = () => {
  const [data, setData] = useState(examinationRows);
  const [loading, setLoading] = useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const { slugs } = useSlug();

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchExaminationRows();
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);

  const handleSaveID = (id, classid, marks, subject_id, subject_name) => {
    localStorage.setItem("examination_id", id);
    localStorage.setItem("Aclass_id", classid);
    localStorage.setItem("total_marks", marks);
    localStorage.setItem("subject_id_for_awardlist", subject_id);
    localStorage.setItem("subject_name_for_awardlist", subject_name);
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${serverUrl}/del_examination/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete record");
      }

      setData((prev) => prev.filter((item) => item.id !== id));
      toast.success("Examination deleted successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete examination.");
    }
  };

  const confirmDelete = () => {
    if (selectedId) {
      handleDelete(selectedId);
      setConfirmOpen(false);
      setSelectedId(null);
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setSelectedId(null);
  };

  const listingLinkString = "Awardlist-Listing";
  const viewLinkString = "Examination-Single";
  const editLinkString = "Examination-Edit";
  const newLinkString = "Examination-New";

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 300,
      renderCell: (params) => (
        <div className="cellAction">
          {slugs?.includes(listingLinkString) && (
            <Link to={`/awardlist`} style={{ textDecoration: "none" }}>
              <div
                className="viewButton"
                onClick={() =>
                  handleSaveID(
                    params.row.id,
                    params.row.class_id,
                    params.row.total_marks,
                    params.row.subject_id,
                    params.row.subject_names,
                  )
                }
              >
                Award List
              </div>
            </Link>
          )}

          {slugs?.includes(viewLinkString) && (
            <Link
              to={`/examinations/${params.row.id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">View</div>
            </Link>
          )}

          {slugs?.includes(editLinkString) && (
            <Link
              to={`/examinations/update-examination/${params.row.id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="editButton">Edit</div>
            </Link>
          )}

          <div
            className="deleteButton"
            onClick={() => {
              setSelectedId(params.row.id);
              setConfirmOpen(true);
            }}
          >
            Delete
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="datatable">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3 pb-2">
        <div className="text-gray-700 text-2xl">Examination Details</div>

        <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
          {slugs?.includes(newLinkString) && (
            <Link to="/examinations/new" className="commonButton">
              Add New
            </Link>
          )}
        </div>
      </div>

      {loading ? (
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={examinationColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar,
          }}
        />
      )}

      <ConfirmModal
        isOpen={confirmOpen}
        title="Delete Examination?"
        message="Are you sure you want to delete this examination record?"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default ExaminationDataTable;
